import { Diagnostic, SensitiveSettingsStorageBase } from '@lmnop/web-core';

export class WebsiteSensitiveSettingsStorage extends SensitiveSettingsStorageBase {
    protected async getSettingsFromStorage(): Promise<any> {
        Diagnostic.debug('WebsiteSensitiveSettingsStorage - getSettingsFromStorage - local.get started');

        let res = JSON.parse(localStorage.getItem('sensitive-settings') ?? 'null', this.jsonPropertyReviver);

        return Promise.resolve(res);
    }

    protected async setSettingsToStorage(settings: any): Promise<void> {
        Diagnostic.debug('WebsiteSensitiveSettingsStorage - setSettingsToStorage - local.set started');

        localStorage.setItem('sensitive-settings', this.getSettingsJSON(settings));

        Diagnostic.debug('WebsiteSensitiveSettingsStorage - setSettingsToStorage - local.set ended');
        return Promise.resolve();
    }
}
